import { useEffect, useState } from "react";
import { WINDOW_KEYS, getSessionStorage, setSessionStorage } from "../utilities/storage";

const useFormCsrfToken = () => {
  const [csrfToken, setCsrfToken] = useState(null);

  //load csrf token from session storage or get a new one from server
  //session storage is not in react state, so we use empty array as dependency
  useEffect(function onFormLoad() {
    const token = getSessionStorage(WINDOW_KEYS.CSRF_TOKEN);
    let endPoint = `${process.env.GATSBY_FORM_ENDPOINT}/csrf`;
    if (token !== null) {
      endPoint += `?token=${token}`;
    }

    const fetchData = async () => {
      try {
        const res = await fetch(endPoint, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        if (data.token) {
          setSessionStorage(WINDOW_KEYS.CSRF_TOKEN, data.token);
          setCsrfToken(data.token);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return csrfToken;
};

export default useFormCsrfToken;
